import getStore from '../store/store';

export default () => getStore().query;
